
import { Rating } from './Rating';
import { Customer } from './Customer';

export class Feedback {
  id?: number;
  text: string;
  rating: Rating;
  createdAt?: string;
  customer?: Customer;

  constructor(init: Partial<Feedback>) {
    this.id = init.id;
    this.text = init.text ?? '';
    this.rating = init.rating ?? new Rating({ id: 0, value: 0 });
    this.createdAt = init.createdAt;
    this.customer = init.customer;
  }
}
